import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const NoContactsPageIconDark = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 308, height = 180, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 308 180"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g opacity="0.5">
          <circle cx="222" cy="93" r="85" fill="#405674" stroke="#405674" strokeWidth="2" />
          <path
            d="M272.117 84.0426C278.208 48.2242 263.622 2.69519 223.504 0.0921979C210.708 -0.733901 198.203 4.02007 191.743 13.2007C169.603 22.0228 167.737 61.3326 170.22 74.862C177.004 111.958 144.302 105.568 152.597 140.389L220.945 136.586H223.566L290.696 137.458C296.355 111.195 269.358 112.956 272.117 84.0582V84.0426Z"
            fill="#27364D"
          />
          <path d="M242.145 79.5688H201.827V131.566H242.145V79.5688Z" fill="#5A7293" />
          <path
            d="M257.654 73.2876C256.158 73.2876 254.94 75.4853 254.94 78.1818C254.94 80.8784 256.158 83.0761 257.654 83.0761C259.15 83.0761 260.368 80.8784 260.368 78.1818C260.368 75.4853 259.15 73.2876 257.654 73.2876ZM257.654 80.9251C256.621 80.9251 255.788 79.4132 255.788 77.5584C255.788 75.7035 256.621 74.1916 257.654 74.1916C258.687 74.1916 259.52 75.7035 259.52 77.5584C259.52 79.4132 258.687 80.9251 257.654 80.9251Z"
            fill="#5A7293"
          />
          <path
            d="M183.433 78.1818C183.433 80.8784 184.651 83.0761 186.147 83.0761C187.642 83.0761 188.86 80.8784 188.86 78.1818C188.86 75.4853 187.642 73.2876 186.147 73.2876C184.651 73.2876 183.433 75.4853 183.433 78.1818ZM184.281 77.5584C184.281 75.7035 185.114 74.1916 186.147 74.1916C187.18 74.1916 188.012 75.7035 188.012 77.5584C188.012 79.4132 187.18 80.9251 186.147 80.9251C185.114 80.9251 184.281 79.4132 184.281 77.5584Z"
            fill="#5A7293"
          />
          <path
            d="M191.713 55.4384C191.713 55.4384 186.486 47.6606 181.12 52.2119C175.755 56.7633 180.982 82.575 191.713 78.0236C202.444 73.4723 191.713 55.4384 191.713 55.4384Z"
            fill="#5A7293"
          />
          <path
            d="M252.243 55.4384C252.243 55.4384 257.47 47.6606 262.836 52.2119C268.201 56.7633 262.974 82.575 252.243 78.0236C241.512 73.4723 252.243 55.4384 252.243 55.4384Z"
            fill="#5A7293"
          />
          <path
            d="M188.443 79.4584C188.258 79.4584 188.058 79.4272 187.888 79.396C187.842 79.396 187.796 79.3493 187.765 79.3181C187.441 80.2845 186.855 80.9391 186.177 80.9391C185.144 80.9391 184.311 79.4272 184.311 77.5724C184.311 75.7176 185.144 74.2212 186.161 74.2056C186.778 74.1277 186.624 73.2704 186.161 73.3016C184.666 73.3016 183.448 75.4993 183.448 78.1959C183.448 80.8924 184.666 83.0901 186.161 83.0901C187.41 83.0901 188.459 81.547 188.782 79.474C188.674 79.474 188.567 79.474 188.443 79.474V79.4584Z"
            fill="#5A7293"
          />
          <path
            d="M257.671 73.2878C257.208 73.2722 257.054 74.1295 257.671 74.1918C258.704 74.1918 259.521 75.7038 259.521 77.5586C259.521 79.4134 258.688 80.9253 257.655 80.9253C257.085 80.9253 256.576 80.4421 256.237 79.694C256.145 79.7719 256.052 79.8498 255.944 79.9278C255.713 80.0681 255.482 80.2083 255.235 80.3486C255.682 81.9541 256.592 83.0763 257.655 83.0763C259.151 83.0763 260.369 80.8786 260.369 78.1821C260.369 75.4855 259.166 73.3034 257.655 73.2878H257.671Z"
            fill="#5A7293"
          />
          <path
            d="M237.905 113.299C229.241 116.666 219.435 116.074 212.219 110.166C207.424 106.238 202.521 100.877 201.658 99.8166L201.966 99.5673C203.662 101.687 212.62 112.224 222.148 112.224C231.677 112.224 240.912 101.406 242.577 99.3179L242.608 110.447C241.714 111.538 239.987 112.489 237.905 113.299Z"
            fill="#405674"
          />
          <path
            d="M190.987 67.9102L190.864 78.3221C190.864 78.3221 190.201 78.4936 189.985 78.5092"
            fill="#405674"
          />
          <path
            d="M183.881 67.6588C182.709 63.5439 180.951 58.2132 184.174 54.5503L185.222 55.7037C182.092 58.6964 183.295 63.7933 183.881 67.6588Z"
            fill="#405674"
          />
          <path
            d="M252.892 67.8779L252.985 78.2899C252.985 78.2899 253.432 78.4614 254.187 78.5393"
            fill="#405674"
          />
          <path
            d="M259.937 67.6588C260.523 63.7933 261.726 58.6808 258.596 55.7037L259.644 54.5503C262.866 58.2132 261.124 63.5439 259.937 67.6588Z"
            fill="#405674"
          />
          <path
            d="M294.985 134.977C276.132 127.01 241.751 121 241.751 121C228.55 132.188 211.857 132.111 201.474 121C201.474 121 166.649 126.193 147 133.112C161.043 158.215 187.231 175.521 217.57 176.908C218.933 176.954 220.28 177 221.659 177C252.854 176.954 280.114 160.095 295 134.961L294.985 134.977Z"
            fill="#303F54"
          />
          <path
            d="M221.932 16.5977C195.937 16.6288 190.032 36.2993 190.572 56.1101C190.572 70.3876 190.479 80.9243 191.79 84.4469C193.1 87.9695 202.212 109.214 221.916 109.261C241.621 109.23 250.733 87.9851 252.043 84.4469C253.354 80.9087 253.277 70.3876 253.277 56.1101C253.816 36.2993 247.911 16.6288 221.916 16.5977H221.932Z"
            fill="#5A7293"
          />
          <path
            d="M190.402 53.8509C190.155 39.9319 200.439 32.6997 200.439 32.6997C209.69 49.097 235.191 54.6614 258.488 46.5251C258.488 46.5251 256.221 7.13735 219.835 9.44419C183.448 11.751 190.417 53.8353 190.417 53.8353L190.402 53.8509Z"
            fill="#27364D"
          />
          <circle cx="86" cy="93.64" r="85" fill="#405674" stroke="#405674" strokeWidth="2" />
          <path d="M110.778 83.0631H61.1738V133.029H110.778V83.0631Z" fill="#5A7293" />
          <path
            d="M105.083 112.345C94.5745 116.374 82.702 115.655 73.9475 108.6C68.1311 103.912 62.1799 97.5166 61.1455 96.2435L61.5053 95.944C63.559 98.4752 74.4122 111.057 85.9699 111.057C97.5276 111.057 108.711 98.1307 110.734 95.6444L110.779 108.93C109.7 110.233 107.601 111.371 105.068 112.33L105.083 112.345Z"
            fill="#405674"
          />
          <path
            d="M129.338 48.0003C126.894 42.1589 121.902 45.0347 121.902 45.0347C124.781 18.509 111.289 1 85.97 1C60.651 1 47.1595 18.509 50.0376 45.0347C50.0376 45.0347 45.0458 42.1739 42.6023 48.0003C40.1589 53.8416 44.6261 67.5163 47.3843 71.8749C50.1426 76.2184 55.0295 75.1999 55.0295 75.1999C55.0295 75.1999 55.3443 84.3963 56.6185 87.7962C57.8927 91.1962 66.7671 111.641 85.9551 111.641C105.143 111.641 114.017 91.1962 115.292 87.7962C116.566 84.3963 116.881 74.8255 116.881 74.8255C116.881 74.8255 121.768 76.2334 124.526 71.8749C127.284 67.5313 131.751 53.8416 129.308 48.0003H129.338Z"
            fill="#5A7293"
          />
          <path
            d="M53.3209 75.2753L52.4814 75.1854C53.9805 73.6277 54.6401 70.8269 54.8649 68.5203L55.1797 65.1653L55.0598 75.1704C55.0598 75.1704 54.4452 75.2753 54.2353 75.2903C54.0105 75.2903 53.3209 75.2603 53.3209 75.2603V75.2753Z"
            fill="#405674"
          />
          <path
            d="M45.9453 61.1655C44.8061 57.2114 43.0971 52.089 46.2302 48.5692L47.2495 49.6776C44.2064 52.5533 45.3757 57.451 45.9453 61.1655Z"
            fill="#405674"
          />
          <path
            d="M126.757 20.3513C117.388 12.7875 108.034 5.25369 100.794 3.41142C96.4466 1.83876 91.4997 1 85.9831 1C68.774 1 54.398 6.28715 52.1794 22.598C44.3393 25.9081 45.7784 38.6841 47.4424 44.3307C47.4424 44.3307 48.7766 44.3008 50.0508 45.0347C53.3936 47.2065 54.1582 53.1227 53.6335 58.979C61.1438 59.0239 55.4623 34.8048 61.3536 28.9336C83.6596 42.9677 113.416 35.5687 113.416 35.5687C114.255 44.7052 113.026 58.994 118.303 58.979C117.778 53.3773 117.763 47.2514 121.886 45.0347C122.455 39.7176 122.365 34.7749 121.676 30.2666C124.284 27.8252 126.548 24.5301 126.743 20.3513H126.757Z"
            fill="#27364D"
          />
          <path
            d="M119.684 74.9602C118.185 73.4025 117.36 70.4669 117.136 68.1603L116.821 64.8053L116.911 74.8105C116.911 74.8105 117.345 74.9303 118.08 75.0052C118.964 75.0801 119.684 74.9602 119.684 74.9602Z"
            fill="#405674"
          />
          <path
            d="M125.888 61.1655C126.458 57.451 127.627 52.5383 124.584 49.6776L125.603 48.5692C128.736 52.089 127.042 57.2114 125.888 61.1655Z"
            fill="#405674"
          />
          <path
            d="M157.505 137.508C133.88 126.979 110.854 123.25 110.854 123.25C99.0418 135.561 71.639 135.741 61.1906 123.25C61.1906 123.25 38.1051 126.979 14.48 137.508C29.1707 161.593 55.704 177.694 86 177.694C116.296 177.694 142.829 161.608 157.52 137.508H157.505Z"
            fill="#303F54"
          />
          <path
            d="M85.1898 139.798C71.4884 139.798 59.451 133.941 51.8657 125.164L52.975 124.895C66.6464 140.741 94.304 146.058 121.527 125.494L122.651 125.764C109.894 135.409 96.8224 139.798 85.1898 139.798Z"
            fill="#405674"
          />
        </g>
      </svg>
    );
  },
);
